module.exports = __webpack_public_path__ + "static/media/42x38-2.6e86f74f.png";